import React, { Component, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form, yupToFormErrors, Field, useFormik } from 'formik';
import { Container, Button, Spinner, Modal, ModalBody, ModalFooter, ModalHeader, Fade, Input, } from 'reactstrap';
import BankValidation from './BankValidation';
import ChooseBank from './ChooseBank';
import DukcapilValidation from './DukcapilValidation';
import { Page1PersonalData } from './Page1PersonalData';
import { Page2Address } from './Page2Address';
import { Page4Job } from './Page4Job';
import { Page5Others } from './Page5Others';
import Page6DokumenPendukung from './Page6DokumenPendukung';
import Page5Agreement from './Page5Agreement';
import Page5AgreementPernyataan from './Page5AgreementPernyataan';
import Page5AgreementPernyataanBCA from './Page5AgreementPernyataanBCA';
import Page5AgreementKetentuan from './Page5AgreementKetentuan';
import Page5AggrementPernyataanBRI from './Page5AgreementPernyataanBRI';
import { Page6Summary } from './Page6Summary';
import Iframe from './Iframe';
import { actionCreators as occupationAction } from '../store/Occupations';
import { positionActions } from '../store/Position.Reducer';
import { registerActions } from '../store/Register.Reducer';
import { businessFieldActions } from '../store/BusinessField.Reducer';
import { provinceActions } from '../store/Province.Reducer';
import { cityActions } from '../store/City.Reducer';
import { bankActions } from '../store/Bank.Reducer';
import { accountOfficerActions } from '../store/AccountOfficer.Reducer';
import { Prompt } from 'react-router';
import { SchemaPage4Job, SchemaPage1Email, SchemaPageDokumenPendukung, SchemaPage1PersonalData, SchemaPageAggreementBank, SchemaPageAggreemenPernyataan, SchemaPageDukcapilValidation } from './validation/Schema';
import Select from "react-select";
import { Persist } from 'formik-persist';
import { withRouter } from 'react-router-dom';
import * as util from 'util'

// import { actionCreators } from '../store/WeatherForecasts';
import * as Yup from "yup";
import { stat } from 'fs';
import BankValidationBRI from './BankValidationBRI';
import Page1Email from './Page1Email';
import UploadProgress from './UploadProgress';

export let defaultValue = {
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Nationality: 'ID',
    KTPNumber: '',

    NPWP: '',
    NPWPNumber: '',
    NPWPAddress1: '',

    NPWPAddressRT: '',
    NPWPAddressRW: '',
    NPWPAddressProvinceId: '',
    NPWPAddressCityId: '',
    NPWPAddressSubDistrict: '',
    NPWPAddressVillage: '',
    NPWPAddressPostalCode: '',

    NPWPAddressIdemWithKTP: true,
    NPWPCity: '',
    NPWPRegistrationDate: '',

    NotHavingNPWPReason: '',
    PassportNumber: '',
    PassportExpiredDate: '',
    BirthPlace: '',
    BirthDate: '',
    EducationId: '',
    GenderId: '',
    Religion: '',
    SpouseName: '',
    MaritalStatusId: '',
    MothersMaidenName: '',

    Address1: '',
    Address2: '',
    Village: '',
    SubDistrict: '',
    CityId: '',
    RT: '',
    RW: '',
    ProvinceId: '',
    PostalCode: '',
    Country: 'ID',

    ResidentialAddressIdem: true,

    ResidentialAddressLine1: '',
    ResidentialAddressCountry: 'ID',
    ResidentialAddressprovinceId: '',
    ResidentialAddressCityId: '',
    ResidentialAddressSubDistrict: '',
    ResidentialAddressVillage: '',
    ResidentialAddressPostalCode: '',
    ResidentialAddressRT: '',
    ResidentialAddressRW: '',

    CorrespondenceAddress: '',
    CorrespondenceAddressCountry: 'ID',
    CorrespondenceAddressLine1: '',
    CorrespondenceAddressprovinceId: '',
    CorrespondenceAddressCityId: '',
    CorrespondenceAddressPostalCode: '',

    HomePhoneAreaCode: '',
    HomePhone: '',
    MobilePhone: '',
    Email: '',
    EmailConfirmation: '',
    Agreement: false,
    OTPEmail: '',

    BankAccountCurrency2: 'IDR',
    BankCode2: '',
    BankAccountHolderName2: '',
    BankAccountNumber2: '',
    MobilePhoneBank: '',

    OccupationId: '',
    OccupationOthers: '',
    PositionId: '',
    PositionOthers: '',
    BusinessFieldId: '',
    BusinessFieldOthers: '',
    IncomePerAnnumId: '',
    FundSourceId: '',
    FundSourceOthers: '',
    CompanyName: '',
    CompanyAddress: '',
    CompanyPhoneAreaCode: '',
    CompanyPhoneNumber: '',
    CompanyAddressCity: '',
    CompanyPostalCode: '',
    LengthOfWork: '',
    DailyNormalTransactionId: '1',

    PartnerOrParentName: '',
    PartnerOrParentRelationshipId: '',
    PartnerOrParentRelationshipOthers: '',
    PartnerOrParentIdentityNumber: '',
    PartnerOrParentJobId: '',
    PartnerOrParentJobOthers: '',
    PartnerOrParentCompanyName: '',
    PartnerOrParentBusinessField: '',
    PartnerOrParentPosition: '',
    PartnerOrParentCompanyAddressLine: '',
    PartnerOrParentCompanyAddressCity: '',
    PartnerOrParentCompanyAddressPostalCode: '',
    PartnerOrParentCompanyPhoneNumber: '',
    PartnerOrParentLengthOfWork: '',
    PartnerOrParentMainIncomeId: '',
    PartnerOrParentMainIncomeSourceId: '',
    PartnerOrParentMainIncomeSourceOthers: '',
    PartnerOrParentAdditionalIncomeId: '',
    PartnerOrParentAdditionalIncomeSourceId: '',
    PartnerOrParentAdditionalIncomeSourceOthers: '',
    PartnerOrParentExpensesPerMonthId: '',

    HeirName: '',
    HeirRelation: '',
    InvestmentObjectiveId: '',
    AssetOwnerId: '1',
    IncomePerAnnumBCA: '',
    FATCAMandatory: '2',
    TINSSN: '',
    TaxpayerOtherContry: '2',
    AgreeTermsPemrek: '',
    AgreeTermsPemrekDate: '',
    AgreementPernyataan: '',

    LongStayAtLastAddress: '',
    LongStayAtLastAddressYear: '',
    HaveAccountsInOtherBank: '2',
    OtherBankOrInstitutionName: '',
    LongOwnershipInOtherBankOrInstitution: '',
    LongOwnershipInOtherBankOrInstitutionYear: '',
    HaveBusinessRelationsWithOverseas: '2',
    BusinessRelationsCountryName: '',
    SourceOfInheritance: '2',
    SourceOfSavings: '2',
    SourceOfBusiness: '2',
    SourceOfGrantOrGift: '2',
    SourceOfSalary: '2',
    SourceOfOther: '0',
    OTPInput: '',
    RegistrationID: '',

    AccountOfficerCode: '0',
    RefferalCode: '',
    EmergencyContactName: '',
    EmergencyContactPhoneNumber: '',
    EmergencyContactRelation: '',

    PhotoKTP: '',
    PhotoSelfie: '',
    PhotoSelfieKTP: '',
    PhotoSpesimen: '',
    SignatureImage: '',
    PhotoSavingBook: '',
    PhotoNPWP: '',
    PhotoDokumenHubunganBeneficialOwner: '',

    AgreePernyataanNasabah: '',
    AgreeKetentuan: '',
    AgreementPernyataan1: '',
    AgreeKetentuan2: '',
    ValidationCode: '',
    BankValidationCode: '',
    RiskLevel: '',
    Page: '',
    BeneficialOwner: {
        OccupationId: '',
        IdentityAddressResidential: true,
        CustomerId: 0,
        ResidentialCityId: 0,
        ResidentialProvinceId: 0,
    }


};


// tslint:disable-next-line:jsx-key
// const pages = [<Page1PersonalData />, <Page2Address />];

class FrmRegister extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //page: localStorage.getItem('page') || -5, totalPages: 5,
            page: -5,
            PhotoKTP: localStorage.getItem('PhotoKTP') || '',
            PhotoSelfie: localStorage.getItem('PhotoSelfie') || '',
            PhotoSelfieKTP: localStorage.getItem('PhotoSelfieKTP') || '',
            PhotoSpesimen: localStorage.getItem('PhotoSpesimen') || '',
            pilihBank: localStorage.getItem('pilihBank') || '',
            data: localStorage.getItem('registrasi'),
            signatureDataUrl: localStorage.getItem('signatureDataUrl') || '',
            RiskLevel: localStorage.getItem('RiskLevel') || '',
            norek: '',
            namaPemegangRekening: '',
            imageValidation: '/api/register/image-validation',
            imageHash: '',
            errors: [],
            error: "error",
            registerError: false,
            modalKodeArea: false,
            modalOTPEmail: false,
            isloadingPendaftaran: false,
            kodeAreaResults: [],
            defaultValue2: defaultValue,
            kodeAreaField: '',
            timer: 300,
            canResendOTP: false,
            //defaultValue: localStorage.getItem('registrasi'),
            //defaultValue: initialValues,
            validationErrors: {},
            showErrorModal: false,
            isLoading: false,
            tncBeneficialOwner: false,
            openModalPhoto: false, PhotoId: '', iframeSrc: '', shouldBlockNavigation: false,
            uploadProgress: 0,
            showUploadProgress: false,
            showSessionExpiredModal: false,
            sessionExpiredReason: ''
        };

        this.nextPage = this.nextPage.bind(this);
        this.sendData = this.sendData.bind(this);
        this.onOccupationChange = this.onOccupationChange.bind(this);
        this.onPositionChange = this.onPositionChange.bind(this);
        this.imageChange = this.imageChange.bind(this);
        this.fotoSelfieKTP = this.fotoSelfieKTP.bind(this);
        this.fotoSpesimen = this.fotoSpesimen.bind(this);
        this.nowRegister = this.nowRegister.bind(this);
        this.setNorek = this.setNorek.bind(this);
        this.setNamaPemegangRekening = this.setNamaPemegangRekening.bind(this);
        this.takePhoto = this.takePhoto.bind(this);
        this.onSnapPhoto = this.onSnapPhoto.bind(this);
        this.onAgreePemrek = this.onAgreePemrek.bind(this);
        this.el = React.createRef();
        //this.receiveMessage = this.receiveMessage.bind(this);
        this.onAgree = this.onAgree.bind(this);
        this.nowVerifikasiDataPribadi = this.nowVerifikasiDataPribadi.bind(this);
        this.copyData = this.copyData.bind(this);
        this.sendDataBypassDigisign = this.sendDataBypassDigisign.bind(this);
        this.onCorrespondenceProvinceChange = this.onCorrespondenceProvinceChange.bind(this);
        this.onCloseMessage = this.onCloseMessage.bind(this);
        this.onPenghasilanPerTahunChange = this.onPenghasilanPerTahunChange.bind(this);
        this.onFundSourceChange = this.onFundSourceChange.bind(this);
        this.nowPilihBank = this.nowPilihBank.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onEmailKonfirmationClick = this.onEmailKonfirmationClick.bind(this);
        this.onNextDokumenPendukungClick = this.onNextDokumenPendukungClick.bind(this);
        this.onPhotoNPWPClick = this.onPhotoNPWPClick.bind(this);
        this.onBusinessFieldChange = this.onBusinessFieldChange.bind(this);
        this.toggleModalKodeArea = this.toggleModalKodeArea.bind(this);
        this.toggleModalOTPEmail = this.toggleModalOTPEmail.bind(this);
        this.handleSearchKodeAreaChange = this.handleSearchKodeAreaChange.bind(this);
        this.verifikasiOTPEmail = this.verifikasiOTPEmail.bind(this);
        this.resendOTP = this.resendOTP.bind(this);
        this.saveTmpData = this.saveTmpData.bind(this);
        this.loadDataSeed = this.loadDataSeed.bind(this);
        this.saveTmpDataManual = this.saveTmpDataManual.bind(this);
        this.convertNullToEmptyString = this.convertNullToEmptyString.bind(this);
        this.cleanUpData = this.cleanUpData.bind(this);
        this.toggleBeneficialOwner = this.toggleBeneficialOwner.bind(this);

        const query = new URLSearchParams(window.location.search);
        const kodeAo = query.get('ao');
        if (kodeAo != null) {
            defaultValue.AccountOfficerCode = kodeAo;
        }
    }

    toggleModalKodeArea = (field = '') => {
        this.setState(prevState => ({
            modalKodeArea: !prevState.modalKodeArea,
            kodeAreaField: field || prevState.kodeAreaField
        }));
        //this.setState(prevState => ({ modalKodeArea: !prevState.modalKodeArea }));
        //this.setState({ kodeAreaField: kodeAreaField });
    }


    toggleBeneficialOwner = () => {
        this.setState(prevState => ({
            tncBeneficialOwner: !prevState.tncBeneficialOwner
        }));
    };

    showSessionExpiredModal = (reason) => {
        this.setState({
            showSessionExpiredModal: true,
            sessionExpiredReason: reason,
            isLoading: false
        });
    };

    handleSessionExpiredClose = () => {
        localStorage.removeItem('verificationToken');
        this.setState({
            showSessionExpiredModal: false,
            sessionExpiredReason: '',
            page: -5 // Go back to email verification page
        });
    };

    getSessionExpiredMessage = () => {
        const { sessionExpiredReason } = this.state;

        if (sessionExpiredReason === 'TOKEN_MISSING') {
            return {
                title: 'Sesi Registrasi Tidak Ditemukan',
                message: 'Token verifikasi tidak ditemukan. Hal ini dapat terjadi karena:',
                reasons: [
                    'Anda membuka halaman ini di browser atau perangkat yang berbeda',
                    'Data browser (cookies/localStorage) telah dihapus',
                    'Anda belum melakukan verifikasi email'
                ],
                action: 'Silakan masukkan email Anda kembali untuk melanjutkan proses registrasi. Data yang sudah tersimpan sebelumnya akan dimuat kembali secara otomatis.'
            };
        } else if (sessionExpiredReason === 'TOKEN_EXPIRED') {
            return {
                title: 'Sesi Registrasi Telah Berakhir',
                message: 'Sesi registrasi Anda telah berakhir karena:',
                reasons: [
                    'Sesi berlaku selama 1 jam sejak verifikasi email terakhir',
                    'Terjadi pemeliharaan sistem pada server'
                ],
                action: 'Silakan masukkan email Anda kembali untuk melanjutkan dari posisi terakhir. Seluruh data yang sudah diisi sebelumnya tetap tersimpan dengan aman.'
            };
        }

        return {
            title: 'Sesi Registrasi Expired',
            message: 'Sesi registrasi Anda telah berakhir.',
            reasons: [],
            action: 'Silakan masukkan email Anda kembali untuk melanjutkan proses registrasi.'
        };
    };

    startTimer = () => {

        this.setState({
            timer: 300,
            isTimerRunning: true,
            canResendOTP: false
        });

        this.intervalRef = setInterval(() => {
            this.setState(prevState => {
                if (prevState.timer === 1) {
                    clearInterval(this.intervalRef);
                    return {
                        timer: 0,
                        isTimerRunning: false,
                        canResendOTP: true
                    };
                }
                return {
                    timer: prevState.timer - 1
                };
            });
        }, 1000);
    }

    toggleModalOTPEmail = () => {
        this.setState(prevState => ({ modalOTPEmail: !prevState.modalOTPEmail }));
    }

    async componentDidMount() {
        this.props.requestOccupations();
        this.props.requestProvinces();
        this.props.requestBanks();
        this.props.requestAccountOfficers();
    }

    async loadDataSeed(register) {
        //const register = this.state.defaultValue2; // JSON.parse(localStorage.getItem("registrasi"));
        console.log('laodDataSeed...');
        if (register) {
            //console.log('register.ProvinceId: ' + register.ProvinceId);
            if (register.ProvinceId !== '') {
                this.props.requestCities(register.ProvinceId);
            }
            if (register.SubDistrict !== '') {
                this.props.requestDistrict(register.CityId);
            }
            if (register.Village !== '') {
                this.props.requestSubDistrict(register.SubDistrict);
            }
            if (register.OccupationId) {
                this.props.requestPositions(register.OccupationId);
            }
            if (register.PositionId) {
                this.props.requestBusinessFields(register.PositionId, register.OccupationId);
            }
            if (register.CorrespondenceAddressprovinceId) {
                this.props.requestCorrespondenceCities(register.CorrespondenceAddressprovinceId);
            }
            if (register.ResidentialAddressprovinceId) {
                this.props.requestResidentialCities(register.ResidentialAddressprovinceId);
            }
            if (register.NPWPAddressProvinceId) {
                this.props.requestNPWPCities(register.NPWPAddressProvinceId);
            }
            if (register.NPWPAddressCityId !== '') {
                this.props.requestNPWPDistricts(register.NPWPAddressCityId);
            }
            if (register.NPWPAddressSubDistrict !== '') {
                this.props.requestNPWPSubDistricts(register.NPWPAddressSubDistrict);
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.page !== this.state.page) {
            //this.ensureDataFetched();
        }

        // this.scrollToBottom();

        // if (this.state.page >= 0) {
        //     window.onbeforeunload = () => true
        // } else {
        //     window.onbeforeunload = undefined
        // }
    }

    async imageChange(e, setFieldValue) {
        const file = e.target.files[0];
        const componentName = e.target.name;

        if (!file) {
            this.setState({ imagePreviewUrl: '' });
            return;
        }

        // Fungsi kompresi gambar
        const compressImage = async (file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = (event) => {
                    const img = new Image();
                    img.src = event.target.result;

                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        let width = img.width;
                        let height = img.height;

                        // Hitung dimensi baru dengan mempertahankan aspect ratio
                        const maxWidth = 1200;
                        const maxHeight = 1200;

                        if (width > height) {
                            if (width > maxWidth) {
                                height = Math.round((height * maxWidth) / width);
                                width = maxWidth;
                            }
                        } else {
                            if (height > maxHeight) {
                                width = Math.round((width * maxHeight) / height);
                                height = maxHeight;
                            }
                        }

                        canvas.width = width;
                        canvas.height = height;

                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);

                        // Kompresi ke JPEG dengan kualitas 0.7
                        canvas.toBlob(
                            (blob) => {
                                // Convert blob to base64
                                const reader = new FileReader();
                                reader.readAsDataURL(blob);
                                reader.onloadend = () => {
                                    resolve(reader.result);
                                };
                            },
                            'image/jpeg',
                            0.7
                        );
                    };
                };
            });
        };

        try {
            // Kompres gambar dan dapatkan base64 string
            const compressedBase64 = await compressImage(file);

            // Update state dan field value dengan hasil kompresi
            this.setState({
                [componentName]: compressedBase64
            });

            setFieldValue(componentName, compressedBase64);

        } catch (error) {
            console.error('Error compressing image:', error);
            // Fallback ke original file jika terjadi error
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({
                    [componentName]: reader.result
                });
                setFieldValue(componentName, reader.result);
            };
            reader.readAsDataURL(file);
        }
    }

    setNorek(norek) {
        defaultValue = { ...defaultValue, BankAccountNumber2: norek };
    }

    setNamaPemegangRekening(namaPemegangRekening) {
        defaultValue = { ...defaultValue, BankAccountHolderName2: namaPemegangRekening.toUpperCase() };
    }

    setStateAsync(state) {
        return new Promise(resolve => {
            this.setState(state, resolve);
        });
    }

    async nowRegister(values, setFieldValue) {

        var namalengkap = values.fullname.toUpperCase();
        var namaDepan = "";
        var namaTengah = "";
        var namaBelakang = "";

        var namalengkaps = namalengkap.split(" ");
        if (namalengkaps.length === 1) {
            namaDepan = namalengkap;
        }
        if (namalengkaps.length === 2) {
            namaDepan = namalengkaps[0];
            namaBelakang = namalengkaps[1];
        }
        if (namalengkaps.length > 2) {
            namaDepan = namalengkaps[0];
            namaTengah = namalengkaps[1];

            for (var ii = 2; ii < namalengkaps.length; ii++) {
                namaBelakang = namaBelakang + " " + namalengkaps[ii];
            }
        }

        //await this.setStateAsync(prevState => ({
        //    defaultValue2: {
        //        ...prevState.defaultValue2,
        //        FirstName: namaDepan,
        //        MiddleName: namaTengah,
        //        LastName: namaBelakang.trim(),
        //        BirthPlace: dataVerifikasi.pob.toUpperCase(),
        //        BirthDate: dataVerifikasi.dob,
        //        Nationality: 'ID',
        //        GenderId: dataVerifikasi.gender,
        //        KTPNumber: dataVerifikasi.nik,
        //    }
        //}));

        setFieldValue('FirstName', namaDepan);
        setFieldValue('MiddleName', namaTengah);
        setFieldValue('LastName', namaBelakang.trim());
        setFieldValue('BirthPlace', values.pob.toUpperCase());
        setFieldValue('BirthDate', values.dob);
        setFieldValue('Nationality', 'ID');
        setFieldValue('GenderId', values.gender);
        setFieldValue('KTPNumber', values.nik);

        //defaultValue = {
        //    ...defaultValue,
        //    FirstName: namaDepan,
        //    MiddleName: namaTengah,
        //    LastName: namaBelakang.trim(),
        //    BirthPlace: dataVerifikasi.pob.toUpperCase(),
        //    // Address1: address1,
        //    // Address2: address2,
        //    // SubDistrict: data.KecName,
        //    // Village: data.KelName,
        //    BirthDate: dataVerifikasi.dob,
        //    Nationality: 'ID',
        //    // RT: data.NoRT,
        //    // RW: data.NoRW,
        //    GenderId: dataVerifikasi.gender,
        //    // MaritalStatusId: maritalstatus,
        //    Email: localStorage.getItem('Email'),
        //    EmailConfirmation: localStorage.getItem('EmailConfirmation'),
        //    BankAccountNumber2: localStorage.getItem('norek'),
        //    BankAccountHolderName2: localStorage.getItem('nama'),
        //    OTPInput: localStorage.getItem('otpInput'),
        //    RegistrationID: localStorage.getItem('registrationID'),
        //    BankCode2: localStorage.getItem('pilihBank'),
        //    SignatureImage: localStorage.getItem('signatureDataUrl'),
        //    PhotoKTP: localStorage.getItem('PhotoKTP'),
        //    BankValidationCode: localStorage.getItem('BankValidationCode'),
        //    PhotoSelfieKTP: localStorage.getItem('PhotoSelfieKTP'),
        //    SignatureImage: localStorage.getItem('signatureDataUrl'),

        //};

        if (values.BankCode2 === 'BRI') {
            setFieldValue('MobilePhone', values.noHandphone);
            setFieldValue('MobilePhoneConfirmation', values.noHandphone);
            setFieldValue('BankAccountHolderName2', values.fullname);
        }

        //if (localStorage.getItem('pilihBank') === 'BRI') {
        //    defaultValue = {
        //        ...defaultValue,
        //        MobilePhone: localStorage.getItem('noHandphone'),
        //        MobilePhoneConfirmation: localStorage.getItem('noHandphone'),
        //        BankAccountHolderName2: dataVerifikasi.fullname,
        //    };
        //}

        //         })
        //         this.setState({ page: 0 });
        //         localStorage.setItem('page', 0);

        // } catch (err) {
        // }

        // console.log('dataVerifikasi:');
        // console.log(JSON.stringify(dataVerifikasi));
        // console.log('data change:');
        // console.log(JSON.stringify(defaultValue));
        // defaultValue.KTPNumber = dataVerifikasi.nik;

        this.setState({ page: 0 });
        //localStorage.setItem('page', 0);

        this.forceUpdate();
        //await this.saveTmpData(this.state.defaultValue2, 0);
    }

    onPhotoNPWPClick = () => {
        alert('Mohon pastikan hal berikut sebelum anda mengambil foto:\n 1. Posisi Handphone tegak lurus/Potrait \n 2. Data yang diambil gambar dan tulisannya dapat terlihat dengan jelas.' +
            '\n3. Pastikan posisi tulisan dapat dibaca dari kiri ke kanan, dapat dibaca dengan jelas dan tidak terpotong');
        return true;
    }

    convertNullToEmptyString = (obj) => {
        return Object.keys(obj).reduce((acc, key) => {
            acc[key] = obj[key] === null ? '' : obj[key];
            return acc;
        }, {});
    };


    async saveTmpData(values, page, setFieldValue = null) {

        const token = localStorage.getItem('verificationToken');


        if (!token) {
            this.showSessionExpiredModal('TOKEN_MISSING');
            throw new Error('Session expired');
        }

        // Create abort controller for timeout (3 minutes to accommodate large photo uploads)
        const controller = new window.AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 180000); // 180 second (3 minutes) timeout

        try {
            const response = await fetch('/api/customertmpregistration', {
                method: "POST",
                headers:
                    new Headers({
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }),
                body: JSON.stringify({ Page: page, Data: values, Email: values.Email, OTPEmail: values.OTPEmail }),
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (response.status === 401) {
                this.showSessionExpiredModal('TOKEN_EXPIRED');
                throw new Error('Session expired');
            }

            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status}`);
            }

            const json = await response.json();

            // Check if backend returned an error response
            if (json.Message === 'Error') {
                console.error('Backend error:', json.ErrorCode, json.ErrorMessage);
                throw new Error(json.ErrorMessage || 'Terjadi kesalahan saat menyimpan data.');
            }

            if (page === -1) {
                localStorage.setItem('KTP', JSON.stringify(json));
                if (setFieldValue !== null) {
                    setFieldValue('nik', json.NIK);
                    setFieldValue('fullname', json.Nama);
                    setFieldValue('pob', json.TmptLahir);
                    setFieldValue('SubDistrict', json.District);
                    setFieldValue('Village', json.Village);
                    setFieldValue('PostalCode', json.PostalCode);

                    const [day, month, year] = json.TglLahir.split('-');
                    var birthDate = `${year}-${month}-${day}`;
                    setFieldValue('dob', birthDate);

                    if (json.JenisKelamin.includes('LAKI')) {
                        setFieldValue('gender', '1');
                    } else {
                        setFieldValue('gender', '2');
                    }
                    setFieldValue('Address1', json.Alamat);
                    const [rt, rw] = json.RTRW.split('/');
                    setFieldValue('RT', rt);
                    setFieldValue('RW', rw);
                    if (json.ProvinceId) {
                        setFieldValue('ProvinceId', json.ProvinceId);
                    }
                    if (json.CityId) {
                        setFieldValue('CityId', json.CityId)
                    }

                }
                if (json.ProvinceId) {
                    this.props.requestCities(json.ProvinceId);
                }
                if (json.CityId) {
                    this.props.requestDistrict(json.CityId);
                }
                if (json.District) {
                    this.props.requestSubDistrict(json.District);
                }
            }
        } catch (error) {
            clearTimeout(timeoutId);
            console.error('Error saving temporary data:', error);

            // Handle specific error types with user-friendly messages
            if (error.name === 'AbortError') {
                throw new Error('Koneksi timeout. Silakan periksa koneksi internet Anda dan coba lagi.');
            } else if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                throw new Error('Gagal terhubung ke server. Silakan periksa koneksi internet Anda dan coba lagi.');
            } else if (error.message.includes('HTTP Error: 500')) {
                throw new Error('Server sedang mengalami gangguan. Silakan coba lagi beberapa saat.');
            } else if (error.message.includes('HTTP Error: 503')) {
                throw new Error('Server sedang dalam pemeliharaan. Silakan coba lagi beberapa saat.');
            }

            throw error; // Re-throw to be handled by caller
        }
    }

    async saveTmpDataManual(values, page) {

        const token = localStorage.getItem('verificationToken');
        if (!token) {
            this.showSessionExpiredModal('TOKEN_MISSING');
            return;
        }

        const response = await fetch('/api/customertmpregistration', {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Page: page, Data: values, Email: values.Email, OTPEmail: values.OTPEmail })
        });

        if (response.status === 401) {
            this.showSessionExpiredModal('TOKEN_EXPIRED');
            return;
        }
        if (response.status === 200) {
            alert('Data berhasil disimpan!');
        }
    }



    async nowVerifikasiDataPribadi(values, setFieldTouched) {
        //this.props.history.push('/register/document');

        this.forceUpdate();

        //await this.saveTmpData(values, -2);
        this.setState({ page: -2 });
        //localStorage.setItem('page', -2);

        for (var propt in defaultValue) {
            setFieldTouched(propt, true, true);
        }
    }

    async nowPilihBank(values) {
        //this.setState({ page: -3 });
        //localStorage.setItem('page', -3);

        this.setState({ isLoading: true });

        try {
            var pilihBank = localStorage.getItem('pilihBank');
            var nohpBank = localStorage.getItem('noHandphone');
            if (pilihBank !== null) {
                if (pilihBank.length > 0) {
                    //localStorage.setItem('page', -3);
                    defaultValue = {
                        ...defaultValue,
                        BankCode2: pilihBank,
                        MobilePhoneBank: nohpBank
                    };
                }
            }

            // Save data first, then change page
            await this.saveTmpData(values, -3);

            // Only change page after successful save
            this.setState({ page: -3, pilihBank: pilihBank, isLoading: false });

        } catch (error) {
            console.error('Error in nowPilihBank:', error);
            this.setState({ isLoading: false });
            alert(error.message || 'Terjadi kesalahan saat menyimpan data. Silakan coba lagi.');
        }

    }

    onAgreePemrek(e, setFieldValue) {
        if (e.target.checked) {
            setFieldValue('AgreeTermsPemrek', '1');
        } else {
            setFieldValue('AgreeTermsPemrek', '');
        }
    }

    onPenghasilanPerTahunChange(e, setFieldValue) {
        const penghasilanPerTahunValue = e.target.value;
        setFieldValue('IncomePerAnnumId', penghasilanPerTahunValue);
        if (penghasilanPerTahunValue === '1' || penghasilanPerTahunValue === '2') {
            setFieldValue('IncomePerAnnumBCA', '1')
        } else if (penghasilanPerTahunValue === '3') {
            setFieldValue('IncomePerAnnumBCA', '2')
        } else if (penghasilanPerTahunValue === '4') {
            setFieldValue('IncomePerAnnumBCA', '3')
        } else if (penghasilanPerTahunValue === '5') {
            setFieldValue('IncomePerAnnumBCA', '4')
        } else if (penghasilanPerTahunValue === '6') {
            setFieldValue('IncomePerAnnumBCA', '5')
        }

    }

    onResidentIdemIdentity(e, setFieldValue, values, requestResidentialCities) {
        if (e.target.checked) {
            setFieldValue('ResidentialAddressIdem', true);
            setFieldValue('ResidentialAddressLine1', values.Address1 + ' ' + values.Address2);
            setFieldValue('ResidentialAddressprovinceId', values.ProvinceId);
            if (values.ProvinceId !== '') {
                requestResidentialCities(values.ProvinceId);
                setFieldValue('ResidentialAddressCityId', values.CityId);
            }
            setFieldValue('ResidentialAddressPostalCode', values.PostalCode);
        } else {
            setFieldValue('ResidentialAddressLine1', '');
            setFieldValue('ResidentialAddressprovinceId', '');
            setFieldValue('ResidentialAddressCityId', '');
            setFieldValue('ResidentialAddressPostalCode', '');
            setFieldValue('ResidentialAddressIdem', false);
        }
    }

    onAgree(e, setFieldValue) {
        const fieldname = e.target.name;
        console.log(fieldname);
        if (e.target.checked) {
            setFieldValue([fieldname], '1');
        } else {
            setFieldValue([fieldname], '');
        }
    }

    fotoSelfieKTP(e, setFieldValue) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                fotoSelfieKTP: reader.result
            });
        }
        setFieldValue('PhotoSelfieKTP', e.target.files[0]);
        if (file != null) {
            reader.readAsDataURL(file);
        } else {
            this.setState({
                fotoSelfieKTP: ''
            });
        }
    }

    fotoSpesimen(e, setFieldValue) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                fotoSpesimen: reader.result
            });
        }
        setFieldValue('PhotoSpesimen', e.target.value);
        if (file != null) {
            reader.readAsDataURL(file)
        } else {
            this.setState({ fotoSpesimen: '' });
        }
    }

    getCurrentSchema = (step) => {
        const schemas = {
            "-5": SchemaPage1Email,
            "-2": SchemaPageDokumenPendukung,
            "-1": SchemaPageDukcapilValidation,
            "0": SchemaPage1PersonalData,
            "1": SchemaPage4Job,
            "2": SchemaPageAggreemenPernyataan,
            "3": SchemaPageAggreementBank,
        };

        return schemas[step] || schemas["-5"];
    };


    getRiskLevel = async (values, setFieldValue, businessFieldId) => {
        const url = `api/riskLevel`;
        const res = await fetch(url, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ProvinceId: values.ProvinceId, OccupationId: values.OccupationId, PositionId: values.PositionId, BusinessFieldId: businessFieldId })
        });
        const data = await res.json();

        if (data.RiskLevel === 'High') {
            localStorage.setItem('RiskLevel', data.RiskLevel);
            this.setState({ RiskLevel: data.RiskLevel });
            setFieldValue('RiskLevel', data.RiskLevel);
        } else {
            localStorage.setItem('RiskLevel', data.RiskLevel);
            this.setState({ RiskLevel: data.RiskLevel });
            setFieldValue('RiskLevel', data.RiskLevel);
        }

    }

    nextPage = async (errors, isValid, setFieldTouched, values, setFieldValue) => {

        for (var propt in defaultValue) {
            setFieldTouched(propt, true, true);
        }

        setFieldTouched('AgreePernyataanNasabah', true, true);
        setFieldTouched('AgreementPernyataan1', true, true);
        setFieldTouched('NotHavingNPWPReason', true, true);


        const errorsString = JSON.stringify(errors);

        if (errorsString.length < 3) {
            //var myPage = Number(localStorage.getItem('page'));

            if (this.state.page == 8 && values.BankCode2 == "BRI") {
                this.setState(state => ({ page: Number(state.page) + 2 }));
                //localStorage.setItem('page', myPage + 2);

                //} else if (this.state.page === 1) {
                //    this.getRiskLevel(values, setFieldValue).then(() => { console.log('')});
                //    localStorage.setItem('page', myPage + 1);


            } else {
                // Show loading indicator while saving
                this.setState({ isLoading: true });

                try {
                    // Wait for save to complete before moving to next page
                    await this.saveTmpData(values, Number(this.state.page) + 1);

                    // Only move to next page after successful save
                    this.setState(state => ({
                        page: Number(state.page) + 1,
                        isLoading: false
                    }));
                } catch (error) {
                    // Handle save error
                    console.error('Error saving temporary data:', error);
                    this.setState({ isLoading: false });
                    alert(error.message || 'Terjadi kesalahan saat menyimpan data. Silakan coba lagi.');
                }

            }

        } else {
            alert('Mohon lengkapi data terlebih dahulu! ' + errorsString);
        }

    };

    backPage = (isValid, setFieldTouched) => {
        var myPage = Number(localStorage.getItem('page'));

        //localStorage.setItem('page', myPage - 1);
        this.setState(state => ({ page: state.page - 1 }));

        //if (this.state.page == 10 && this.state.pilihBank == "BRI") {
        //    localStorage.setItem('page', myPage - 2);
        //    this.setState(state => ({ page: state.page - 2 }));
        //} else {

        //    var RiskLevel = localStorage.getItem('RiskLevel');


        //    if (myPage === 3) {
        //        if (RiskLevel === 'High') {
        //            this.setState(state => ({ page: Number(state.page) - 1 }));
        //            localStorage.setItem('page', myPage - 1);
        //        } else {
        //            this.setState(state => ({ page: Number(state.page) - 2 }));
        //            localStorage.setItem('page', myPage - 2);
        //        }
        //    } else {
        //        localStorage.setItem('page', myPage - 1);
        //        this.setState(state => ({ page: state.page - 1 }));
        //    }
        //}
        for (var propt in defaultValue) {
            setFieldTouched(propt, true, true);
        }
    };

    scrollToBottom = () => {
        this.el.scrollIntoView({ behavior: "smooth" });
    };


    onOccupationChange = async (e, setFieldValue) => {
        const { name, value } = e.target;

        if (e.target.name == 'OccupationId') {
            if (value !== '') {
                await this.props.requestPositions(value);

                const positions = this.props.positions;
                
                // Check if positions array has elements before accessing
                if (positions && positions.length > 0) {
                    await this.props.requestBusinessFields(positions[0].Id, value);

                    const businessFields = this.props.businessFields;

                    setFieldValue('OccupationId', value);

                    if (value !== '8') {
                        setFieldValue('PositionId', positions[0].Id);

                        if (businessFields && businessFields.length > 0) {
                            setFieldValue('BusinessFieldId', businessFields[0].Id);
                        } else {
                            setFieldValue('BusinessFieldId', '');
                        }
                    }
                } else {
                    // No positions available for this occupation (e.g., "Lainnya")
                    setFieldValue('OccupationId', value);
                    setFieldValue('PositionId', '');
                    setFieldValue('BusinessFieldId', '');
                }

                if (value == '3' || value == '7') {
                    this.setState({
                        tncBeneficialOwner: true
                    });
                }
            } else {
                setFieldValue('OccupationId', value);
                setFieldValue('PositionId', '');
                setFieldValue('BusinessFieldId', '');
            }
        } else if (name == 'BeneficialOwner.OccupationId') {
            setFieldValue(name, value);
            if (value !== '')
                await this.props.requestBOPositions(value);
        } else if (name == 'PartnerOrParentJobId') {
            setFieldValue(name, value);
            if (value !== '')
                await this.props.requestPartnerOrParentPositions(value);
        }
        this.forceUpdate();
    };



    onPositionChange = (e, occupationId, setFieldValue, values) => {

        const { name, value } = e.target;
        if (name == 'PositionId') {
            if (e.target.value !== '') {
                this.props.requestBusinessFields(value, occupationId);
                if (this.props.businessFields.length == 1) {
                    const businessFieldId = this.props.businessFields[0].Id;
                    setFieldValue('BusinessFieldId', businessFieldId);

                    this.getRiskLevel(values, setFieldValue, businessFieldId).then(() => { console.log('') });
                } else {
                    setFieldValue('BusinessFieldId', '');
                }
            } else {
                setFieldValue('BusinessFieldId', '');
            }
            setFieldValue('PositionId', e.target.value);
        } else if (name == 'BeneficialOwner.PositionId') {
            setFieldValue(name, value);
            if (value !== '41')
                setFieldValue('BeneficialOwner.Position', e.target.selectedOptions[0].text);
            this.props.requestBOBusinessFields(value, occupationId);
        } else if (name == 'PartnerOrParentPositionId') {
            setFieldValue(name, value);
            if (value !== '41')
                setFieldValue('PartnerOrParentPosition', e.target.selectedOptions[0].text);

            if (value !== '')
                this.props.requestPartnerOrParentBusinessFields(value, occupationId);
        }
    };

    onBusinessFieldChange = (e, setFieldValue, values) => {
        const { name, value } = e.target;
        if (name == 'BusinessFieldId') {
            setFieldValue('BusinessFieldId', e.target.value);
            this.getRiskLevel(values, setFieldValue, e.target.value).then(() => { console.log('') });
        } else if (name == 'BeneficialOwner.BusinessFieldId') {
            setFieldValue(name, value);
            if (value !== '25')
                setFieldValue('BeneficialOwner.BusinessField', e.target.selectedOptions[0].text);
        } else if (name == 'PartnerOrParentBusinessFieldId') {
            setFieldValue(name, value);
            if (value !== '25')
                setFieldValue('PartnerOrParentBusinessField', e.target.selectedOptions[0].text);
        }
    };

    onFundSourceChange = (e, setFieldValue) => {
        setFieldValue('FundSourceId', e.target.value);
        if (e.target.value === '2') {
            setFieldValue('SourceOfSalary', '1');
            setFieldValue('SourceOfBusiness', '2');
        } else if (e.target.value === '3') {
            setFieldValue('SourceOfBusiness', '1');
            setFieldValue('SourceOfSalary', '2');
        }
        else {
            setFieldValue('SourceOfSalary', '2')
            setFieldValue('SourceOfBusiness', '2')
        }
    }

    onTINSSNMandatoryChange = (e, setFieldValue) => {
        setFieldValue('TINSSNMandatory', e.target.value);
        if (e.target.value === "2") {
            setFieldValue('TINSSN', '');
        }
    };


    onValueChange = (e, setFieldValue) => {
        const { value, name } = e.target;
        setFieldValue(name, value);

        const clearFields = (fields) => {
            fields.forEach(field => setFieldValue(field, ''));
        };

        switch (name) {
            case "ProvinceId":
                this.props.requestCities(value);
                this.props.requestDistrict('');
                this.props.requestSubDistrict('');
                clearFields(['SubDistrict', 'Village', 'PostalCode']);
                break;
            case "CityId":
                this.props.requestDistrict(value);
                this.props.requestSubDistrict('');
                clearFields(['SubDistrict', 'Village', 'PostalCode']);
                break;
            case "SubDistrict":
                this.props.requestSubDistrict(value);
                clearFields(['Village', 'PostalCode']);
                break;
            case "Village":
                var subDistrict = this.props.subDistricts.find(city => city.Name === value);
                setFieldValue('PostalCode', subDistrict ? subDistrict.PostalCode : '');
                break;
            case "ResidentialAddressVillage":
                var subDistrict = this.props.residentialSubDistricts.find(city => city.Name === value);
                setFieldValue('ResidentialAddressPostalCode', subDistrict ? subDistrict.PostalCode : '');
                break;
            case "ResidentialAddressprovinceId":
                this.props.requestResidentialCities(value);
                break;
            case "ResidentialAddressCityId":
                this.props.requestResidentialDistricts(value);
                break;
            case "ResidentialAddressSubDistrict":
                this.props.requestResidentialSubDistricts(value);
                break;
            case "NPWPAddressProvinceId":
                this.props.requestNPWPCities(value);
                break;
            case "NPWPAddressCityId":
                this.props.requestNPWPDistricts(value);
                break;
            case "NPWPAddressSubDistrict":
                this.props.requestNPWPSubDistricts(value);
                break;
            case "NPWPAddressVillage":
                var subDistrict = this.props.npwpSubDistricts.find(city => city.Name === value);
                setFieldValue('NPWPAddressPostalCode', subDistrict ? subDistrict.PostalCode : '');
                break;
            case "BeneficialOwner.IdentityProvinceId":
                this.props.requestBOIdentityCities(value);
                break;
            case "BeneficialOwner.IdentityCityId":
                this.props.requestBOIdentityDistricts(value);
                break;
            case "BeneficialOwner.IdentitySubDistrict":
                this.props.requestBOIdentitySubDistricts(value);
                break;
            case "BeneficialOwner.ResidentialProvinceId":
                this.props.requestBOResidentialCities(value);
                break;
            case "BeneficialOwner.ResidentialCityId":
                this.props.requestBOResidentialDistricts(value);
                break;
            case "BeneficialOwner.ResidentialSubDistrict":
                this.props.requestBOResidentialSubDistricts(value);
                break;
            case "NPWP":
                if (value === "1") {
                    setFieldValue("NPWPNumber", "");
                    setFieldValue("PhotoNPWP", "");
                }
                break;
        }
    }

    //onResidentialProvinceChange = (e, setFieldValue) => {
    //    this.props.requestResidentialCities(e.target.value);
    //    setFieldValue('ResidentialAddressprovinceId', e.target.value);
    //};

    onCorrespondenceProvinceChange = (e, setFieldValue) => {
        this.props.requestCorrespondenceCities(e.target.value);
        setFieldValue('CorrespondenceAddressprovinceId', e.target.value);
    };

    onHaveAccountsInOtherBank = (e, setFieldValue) => {
        if (e.target.value == '1') {
            setFieldValue('OtherBankOrInstitutionName', '');
        }
    };



    finish = () => {
        const loopCheckRegisterStatus = setInterval(() => this.checkRegisterStatus(loopCheckRegisterStatus), 10000);
    };

    async receiveMessage(event) {
        var source = event.source.frameElement; //this is the iframe that sent the message

        var message = event.data; //this is the message
        // console.log('message[rc]: ' + JSON.stringify(message));
        var stringMessage = JSON.stringify(message);
        console.log('stringMessage:' + stringMessage);
        var dataJson = null;

        try {
            dataJson = JSON.parse(message);
        } catch (err) {
            dataJson = JSON.parse(stringMessage);
        }

        // if (stringMessage === '{"result":"01","notif":"go back"}'){
        //     dataJson = JSON.parse(stringMessage);
        // } else {
        //     dataJson = JSON.parse(message);
        // }
        // alert(dataJson.rc + ' : ' + dataJson.notif);
        // console.log(JSON.stringify(event.origin));
        // console.log('message receive: ' + JSON.stringify(dataJson));

        if (dataJson.result === "01") {
            this.setState({ iframeSrc: '' });
        }
        if (dataJson.result === "00") {
            this.setState({ iframeSrc: '' });

            // Download Document
            const url = `api/register/finish?ref=` + this.props.register.id;
            const response = await fetch(url, {
                method: "GET",
                contentType: false,
                processData: false
            }).then((data) => {
                console.log(data);
            });
            // Download Document

            window.location = '/register-succeed?id=' + this.props.register.id;
        }

        if (dataJson.rc === "12") {
            this.setState({ iframeSrc: '', isLoading: false });
            alert('error 12: ' + dataJson.notif);
        }
        if (dataJson.rc === "14") {
            this.setState({ iframeSrc: '', isLoading: false });
            alert('error 14: ' + dataJson.notif);
        }
        if (dataJson.rc === "28") {
            this.setState({ iframeSrc: '', isLoading: false });
            alert('error 28: ' + dataJson.notif);
        }
        if (dataJson.rc === "00") {
            this.setState({ iframeSrc: '/api/register/signdocument?ref=' + this.props.register.Id });
            // this.setState({iframeSrc: '/api/register/signdocument?ref=9b164b6615b141e1ba2ca568deace8e9'});
        }
        dataJson = null;

    }

    //ini pakai digisign flow
    async sendData(values) {
        try {
            const hasil = await this.props.createCustomer(values);

            // console.log(this.props.register.id);
            // console.log(JSON.stringify(this.props.register));

            if (this.props.register != null) {
                if (typeof this.props.register.Id !== "undefined") {


                    // var hasilActivation = await this.props.customerActivation(this.props.register.id);
                    alert('pastikan anda telah melakukan tanda tangan pada halaman 6 dan 18 sebelum memproses dokumen');
                    this.setState({ iframeSrc: '/api/register/activation?ref=' + this.props.register.Id });

                    // const url = `api/register/activation?ref=` + this.props.register.id;
                    // const response = await fetch(url, {
                    //     method: "GET",
                    //     contentType: false,
                    //     processData: false
                    // }).then((data) => {
                    //     console.log(data);
                    // });
                    // console.log(response.text());
                } else {
                    this.setState({ isLoading: false, registerError: true });
                }
            }

        } catch (err) {
            // console.log(err);
        }
        // alert('Data sudah dikirim!');
        // window.location.reload();
    };

    async sendDataBypassDigisign(values) {

        try {
            // Show upload progress modal
            this.setState({
                showUploadProgress: true,
                uploadProgress: 0,
                isLoading: false,
                registerError: false
            });

            values = {
                ...values,
                BankValidationCode: localStorage.getItem('BankValidationCode'),
                BeneficialOwner: {
                    ...values.BeneficialOwner,
                    CustomerId: 0,
                }
            };

            if (values.OccupationId !== '3' && values.OccupationId !== '7') {
                values = {
                    ...values,
                    BeneficialOwner: {}
                }
            }

            // Create progress callback - cap at 95% until we get successful response
            const onProgress = (percentComplete) => {
                // Cap progress at 95% during upload, reserve 100% for successful response only
                const cappedProgress = Math.min(percentComplete, 95);
                this.setState({ uploadProgress: cappedProgress });
            };

            // Call createCustomer with progress callback
            const hasil = await this.props.createCustomer(values, onProgress);

            // Only reach 100% after successful response
            this.setState({ uploadProgress: 100 });

            // Wait a moment to show 100% before redirecting
            await new Promise(resolve => setTimeout(resolve, 1000));

            //console.log('hasil: ' + hasil);
            //console.log('register: ' + JSON.stringify(this.props.register));
            let errors = [];
            if (this.props.register.Id !== undefined) {
                localStorage.clear();
                window.location = "/register-succeed?ref=" + this.props.register.Id;
            } else {
                // Handle unexpected response format
                this.setState({
                    isLoading: false,
                    registerError: true,
                    showUploadProgress: false,
                    uploadProgress: 0
                });
                this.reloadCaptcha();
            }
        } catch (err) {
            // Handle error responses (400, 500, etc.)
            console.error('Registration error:', err);

            let errorMessage = 'Terjadi kesalahan saat mengirim data.';

            // Check if we have error details from server
            if (err.status) {
                if (err.status === 400) {
                    errorMessage = 'Data yang dikirim tidak valid. Silakan periksa kembali formulir Anda.';
                } else if (err.status === 401 || err.status === 403) {
                    errorMessage = 'Sesi Anda telah berakhir. Silakan muat ulang halaman.';
                } else if (err.status >= 500) {
                    errorMessage = 'Terjadi kesalahan pada server. Silakan coba lagi nanti.';
                }
            }

            // Hide upload progress on error and show error modal
            this.setState({
                showUploadProgress: false,
                uploadProgress: 0,
                isLoading: false,
                registerError: true
            });

            // Show alert with error message
            alert(errorMessage);

            this.reloadCaptcha();
        }
    };



    async copyData(setFieldValue, values) {
        try {
            const url = `api/validation/personal-data?nik=` + values.KTPNumber;
            const res = await fetch(url, {
                method: "GET",
                headers: { 'Content-Type': 'application/json' }
            });
            const data = await res.json();

            var namalengkap = data.namaLgkp;
            var namaDepan = "";
            var namaTengah = "";
            var namaBelakang = "";


            var namalengkaps = namalengkap.split(" ");
            if (namalengkaps.length() === 1) {
                namaDepan = namalengkap;
            }
            if (namalengkaps.length() === 2) {
                namaDepan = namalengkaps[0];
                namaBelakang = namalengkaps[1];
            }
            if (namalengkaps.length > 2) {
                namaDepan = namalengkaps[0];
                namaTengah = namalengkaps[1];

                for (var ii = 1; ii < namalengkaps.length(); ii++) {
                    namaBelakang = namaBelakang + " " + namalengkaps[ii];
                }
            }
            setFieldValue('FirstName', namaDepan);
            setFieldValue('MiddleName', namaTengah);
            setFieldValue('LastName', namaBelakang);
            setFieldValue('BirthPlace', data.TmptLhr);
            setFieldValue('BirthDate', data.TglLhr.substring(0, 10));
            setFieldValue('RT', data.NoRT);
            setFieldValue('RW', data.NoRW);
            // if (data.jenisKlmin === "Laki-Laki") {
            //     setFieldValue('GenderId', 1);
            // } else {
            //     setFieldValue('GenderId', 2);
            // }
            /// error gender di summary 
            alert('Data berhasil dicopy');
        } catch (err) {
            // console.log(err);
        }

    };

    takePhoto = (a) => {
        if (a === 'PhotoSelfie') {
            alert('Mohon pastikan hal berikut sebelum anda mengambil foto:\n 1. Posisi Handphone tegak lurus/Potrait \n 2. Data yang diambil gambar dan tulisannya dapat terlihat dengan jelas.');
        }
        this.setState({ openModalPhoto: true, PhotoId: a });
    };

    onSnapPhoto = (dataUri, setFieldValue) => {
        this.setState({ [this.state.PhotoId]: dataUri });
        localStorage.setItem([this.state.PhotoId], dataUri);
        setFieldValue(this.state.PhotoId, dataUri);
        this.setState({ openModalPhoto: false });
    };

    handleSearchKodeAreaChange = (e) => {

        const { value } = e.target;

        console.log(value);

        //this.setState({ input: value });

        if (value.length > 2) {
            fetch(`/api/kodearea/search?q=${encodeURIComponent(value)}`)
                .then(response => response.json())
                .then(data => {
                    this.setState({ kodeAreaResults: data }); // Adjust according to your API response structure
                })
                .catch(error => {
                    console.error('Error fetching the data:', error);
                    this.setState({ kodeAreaResults: [] });
                });
        } else {
            this.setState({ results: [] });
        }
    }


    onCloseMessage = () => {
        this.setState({ registerError: false });
    };

    selectKodeArea = (item, setFieldValue) => {
        const { kodeAreaField } = this.state;
        setFieldValue(kodeAreaField, item.Kode);

        this.setState({ modalKodeArea: false });  // Optionally close the modal upon selection
    }

    checkRegisterStatus = (loopCheckRegisterStatus) => {
        console.log(this.props.register);
        // console.log('status:::' + this.props.registerStatus);

        if (this.props.registerStatus === "FINISH") {
            clearInterval(loopCheckRegisterStatus);
            localStorage.clear();
            window.location = '/register-succeed';
        }
        if (this.props.register != null) {
            // by pass check looping status
            // clearInterval(loopCheckRegisterStatus);
            // window.location = '/register-succeed';
            // bypass check looping status

            this.props.checkRegisterStatus(this.props.register.id);
        }
    };

    onEmailKonfirmationClick = async (isValid, setFieldTouched, setFieldValue, values) => {

        this.setState({ isLoading: true }, () => {
            this.forceUpdate();
        });

        setFieldTouched('Email', true, true);
        setFieldTouched('EmailConfirmation', true, true);



        if (values.Email !== "" && values.EmailConfirmation !== "") {
            fetch(`/api/OTPEmail/generate?email=` + values.Email)
                .then(response => response.json())
                .then(data => {
                    if (data.ErrorCode !== "00") {
                        alert(data.Message);
                    } else {
                        this.setState({ modalOTPEmail: true, isLoading: false });
                        this.startTimer();
                    }
                })
                .catch(error => {
                    alert('Mohon maaf, terjadi kesalahan pada sistem. [error:6287]');
                    this.setState({ isLoading: false });
                });
        }

        /// kode referal ao
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const ref = params.get('ref');
        if (ref != undefined) {
            const response = await fetch("/api/ao?reff=" + ref);
            const hasil = await response.text();
            setFieldValue('AccountOfficerCode', hasil);
        }

        this.setState({ isLoading: false }, () => {
            this.forceUpdate();
        });

    }

    resendOTP = (values) => {
        fetch(`/api/OTPEmail/generate?email=` + values.Email)
            .then(response => response.json())
            .then(data => {
                if (data.ErrorCode === "00") {
                    alert('Email OTP sudah dikirimkan ulang.');
                } else {
                    alert(data.Message);
                    this.setState({ modalOTPEmail: false });
                }
            })
            .catch(error => {
                alert('Mohon maaf, terjadi kesalahan pada sistem. [error:6285]');
            });
    }

    verifikasiOTPEmail = async (values) => {
        //fetch(`/api/OTPEmail/verifikasi?email=` + values.Email + "&code=" + values.OTPEmail)
        //    .then(response => response.json())
        //    .then(data => {
        //        if (data.ErrorCode === "00") {

        //            if (data.Page !== undefined) {
        //                //this.setState({ page: data.Page });
        //                //localStorage.setItem('page', data.Page);
        //                //this.setState({ defaultValue2: JSON.parse(data.Data) });

        //                const dataParsed = JSON.parse(data.Data);
        //                this.loadDataSeed(dataParsed);
        //                this.setState({ modalOTPEmail: false, page: data.Page, defaultValue2: dataParsed });
        //            } else {
        //               this.setState({ page: -4, modalOTPEmail: false });
        //            }


        //        } else {
        //            alert(data.Message);
        //        }
        //    })
        //    .catch(error => {
        //        alert('Mohon maaf, terjadi kesalahan pada sistem. [error:6287]');
        //    });

        this.setState({ isLoading: true }, () => {
            this.forceUpdate();
        });

        try {
            const response = await fetch(`/api/OTPEmail/verifikasi?email=` + values.Email + "&code=" + values.OTPEmail);
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }
            const data = await response.json();
            if (data.ErrorCode === "00") {
                if (data.Page !== undefined) {
                    //this.setState({ page: data.Page });
                    //localStorage.setItem('page', data.Page);

                    localStorage.setItem('verificationToken', data.Token);
                    const dataParsed = JSON.parse(data.Data);
                    const dataRemovenull = this.convertNullToEmptyString(dataParsed);
                    //await this.loadDataSeed(JSON.parse(data.Data));
                    await this.loadDataSeed(dataRemovenull);

                    this.setState({ modalOTPEmail: false, page: data.Page, defaultValue2: dataRemovenull });

                } else {
                    this.setState({ page: -4, modalOTPEmail: false });
                    localStorage.setItem('verificationToken', data.Token);
                }
            }
            else {
                alert(data.Message);
            }
        } catch (error) {

        }
        this.setState({ isLoading: false }, () => {
            this.forceUpdate();
        });

    }


    cleanUpData = async (values) => {
        if (window.confirm('Apakah Anda yakin ingin menghapus data?') == true) {
            try {
                const token = localStorage.getItem('verificationToken');
                const response = await fetch(`/api/customertmpregistration/cleanup?email=` + values.Email, {
                    method: "GET",
                    headers:
                        new Headers({
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }),

                });
                if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                }
                const data = await response.json();
                if (data.ErrorCode === "00") {
                    alert('Data Anda sudah dibersihkan, silakan mengisi ulang data Anda');
                    window.location = '';
                }
                else {
                    alert(data.Message);
                }
            } catch (error) {
                alert('error');
            }
        } else {

        }
    }

    onNextDokumenPendukungClick = async (isValid, setFieldTouched, values, validateForm, setFieldValue) => {

        //// Validate all fields on the current page
        //const errors = await validateForm();
        this.setState({ isLoading: true }, () => {
            this.forceUpdate();
        });
        for (var propt in defaultValue) {
            setFieldTouched(propt, true, true);
        }

        if (isValid) {
            try {
                //localStorage.setItem('page', '-1');
                await this.saveTmpData(values, -1, setFieldValue);
                this.setState({ page: -1, isLoading: false });
            } catch (error) {
                console.error('Error in onNextDokumenPendukungClick:', error);
                this.setState({ isLoading: false });
                alert(error.message || 'Terjadi kesalahan saat menyimpan data. Silakan coba lagi.');
            }
        }
        else {
            alert('Mohon lengkapi dokumen pendukung.');
            this.setState({ isLoading: false }, () => {
                this.forceUpdate();
            });
        }
    }

    reloadCaptcha = () => {
        this.setState({ imageHash: Date.now() });
    }

    render() {
        const { page, modalKodeArea, kodeAreaResults, modalOTPEmail, isLoading, isloadingPendaftaran, defaultValue2 } = this.state;
        const { occupations, positions } = this.props;
        const { schemaArray, state, props } = this;
        return (
            <React.Fragment>

                <Container>
                    <Prompt
                        when={this.state.page >= 0}
                        message='Data yang Anda masukan belum tersimpan, apakah Anda yakin ingin meninggalkan situs ini?'
                    />

                    <Iframe source={this.state.iframeSrc} />

                    <Modal isOpen={isLoading}>
                        <ModalBody className="text-center">
                            <Spinner color="success" /><br />Loading, please wait..
                        </ModalBody>
                    </Modal>

                    <Modal isOpen={isloadingPendaftaran}>
                        <ModalBody className="text-center">
                            <Spinner color="success" /><br />Pendaftaran Anda sedang diproses, mohon tunggu..
                        </ModalBody>
                    </Modal>

                    <Modal isOpen={this.state.showUploadProgress} size="lg">
                        <ModalBody>
                            <UploadProgress progress={this.state.uploadProgress} />
                        </ModalBody>
                    </Modal>

                    {this.state.showErrorModal ?
                        <Modal isOpen={true}>
                            <ModalBody className="text-center">
                                error
                            </ModalBody>
                        </Modal>
                        : null}

                    {this.state.registerError ?
                        <Modal isOpen={true}>
                            <ModalHeader size={"sm"} toggle={() => this.onCloseMessage()}>{this.props.register.title}</ModalHeader>
                            <ModalBody className="text-center">
                                {this.props.register.errors != null ?
                                    <ul>
                                        {Object.keys(this.props.register.errors).map(function (key) {
                                            return <li className={"text-danger"}>{this.props.register.errors[key][0]}</li>
                                        }, this)
                                        }
                                    </ul>
                                    : null}

                                <span className={"text-danger"}> {this.props.register.message}</span>
                            </ModalBody>
                            <ModalFooter>
                                <Button size={"sm"} color="primary" onClick={() => this.onCloseMessage()}>Close</Button>
                            </ModalFooter>
                        </Modal>
                        : null}

                    {/*{this.state.page == -3 && this.state.pilihBank == 'BCA' ? (*/}
                    {/*    <BankValidation nowVerifikasiDataPribadi={this.nowVerifikasiDataPribadi} setNorek={this.setNorek} setNamaPemegangRekening={this.setNamaPemegangRekening} />*/}
                    {/*) : null}*/}
                    {/*{this.state.page == -3 && this.state.pilihBank == 'BRI' ? (*/}
                    {/*    <BankValidationBRI nowVerifikasiDataPribadi={this.nowVerifikasiDataPribadi} setNorek={this.setNorek} setNamaPemegangRekening={this.setNamaPemegangRekening} />*/}
                    {/*) : null}*/}


                    {this.state.errors.length > 0 ? (
                        <div class="alert alert-danger alert-dismissible fade show" >
                            <strong>Error!</strong> A problem has been occurred while submitting your data.
                            <ul>{this.state.errors.map((item, key) => <li>{item}</li>)}
                            </ul>
                        </div>
                    ) : null}
                    <Formik
                        initialValues={defaultValue2}
                        validateOnMount={true}
                        enableReinitialize={true}


                        onSubmit={values => {
                            // console.log(values);
                            // this.props.requestJabatans(0, values);
                            this.setState({ isLoading: true });
                            // this.props.createCustomer(values);
                            // this.sendData(values);

                            this.sendDataBypassDigisign(values);
                            // this.finish();
                        }}

                        validationSchema={this.getCurrentSchema(page)}
                    //validationSchema={schemaArray[Number(page)]}
                    >
                        {({ errors, touched, values, isValid, dirty, setFieldValue, setFieldTouched, handleChange, handleBlur, validateForm }) => (




                            <Form autoComplete="off" >

                                {this.state.page >= -1 && this.state.page < 0 ? (
                                    <DukcapilValidation nowRegister={this.nowRegister} touched={touched} errors={errors} isValid={isValid} values={values} setFieldValue={setFieldValue} />
                                ) : null}

                                {dirty}

                                {this.state.page == 4 ?
                                    Object.entries(errors).map(([fieldName, errorMessage]) =>
                                        <li key={fieldName} className="text-danger">
                                            {fieldName} : {errorMessage}
                                        </li>
                                    )
                                    : null}

                                <Modal isOpen={modalKodeArea} toggle={this.toggleModalKodeArea} size="xl" className="modal-fullscreen">
                                    <ModalHeader toggle={this.toggleModalKodeArea}>Pencarian Kode Area</ModalHeader>
                                    <ModalBody>
                                        <Input
                                            type="text"
                                            placeholder="Cari menggunakan nama kota atau daerah..."
                                            className="mb-3"
                                            onChange={(e) => this.handleSearchKodeAreaChange(e)}
                                        />
                                        <div>
                                            {kodeAreaResults.map((item, index) => (
                                                <div onClick={() => this.selectKodeArea(item, setFieldValue)} className="row"
                                                    key={index} style={{ cursor: 'pointer', borderBottom: 'solid #ccc 1px', padding: '5px 0 5px 0' }}>

                                                    <div className="col-xs-8" >
                                                        {item.Provinsi} - {item.Kota} -
                                                    </div>
                                                    <div className="col-xs-4 " >
                                                        &nbsp; <b>{item.Kode}</b>
                                                    </div>

                                                </div>  // Adjust as needed
                                            ))}
                                        </div>
                                    </ModalBody>
                                </Modal>

                                <Modal isOpen={this.state.tncBeneficialOwner}>

                                    <ModalBody>
                                        Merujuk kepada Peraturan Otoritas Jasa Keuangan Nomor 8 Tahun 2023 tentang
                                        Penerapan Program Anti Pencucian Uang, Pencegahan Pendanaan Terorisme,
                                        dan Pencegahan Pendanaan Proliferasi Senjata Pemusnahan Massal (APU, PPT,
                                        dan PPPSPM).<br /><br />
                                        Pembukaan Rekening Efek dan Rekening Dana Nasabah untuk <b>nasabah
                                            Individu dengan pekerjaan Ibu RumahTangga/Pelajar/Mahasiswa wajib
                                            melengkapi data Pemilik Manfaat (Beneficial Owner). </b>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="primary" className="btn-sm" onClick={this.toggleBeneficialOwner}>
                                            Saya Setuju
                                        </Button>{' '}
                                    </ModalFooter>
                                </Modal>

                                <Modal isOpen={modalOTPEmail} toggle={this.toggleModalOTPEmail} >
                                    <ModalHeader toggle={this.toggleModalOTPEmail}>Verifikasi OTP</ModalHeader>
                                    <ModalBody>
                                        <label>Masukan OTP yang dikirimkan ke email</label>
                                        <Input
                                            type="tel"
                                            placeholder="Masukkan kode OTP"
                                            name="OTPEmail"
                                            id="OTPEmail"
                                            maxLength="6"
                                            tag={Field}
                                            className="mb-3"
                                        />
                                        {this.state.canResendOTP ?
                                            <Button type="button" className="btn btn-secondary btn-sm" onClick={() => this.resendOTP(values)} >Kirim Ulang OTP</Button>
                                            :
                                            <p className="text-gray-600">
                                                Kirim ulang OTP dalam <b>{Math.floor(this.state.timer / 60)}:{(this.state.timer % 60).toString().padStart(2, '0')}</b>
                                            </p>}
                                        &nbsp; <Button type="button" className="btn btn-primary btn-sm" onClick={() => this.verifikasiOTPEmail(values)} >Verifikasi</Button>
                                    </ModalBody>
                                </Modal>

                                {/* Session Expired Modal */}
                                <Modal isOpen={this.state.showSessionExpiredModal} backdrop="static" keyboard={false}>
                                    <ModalHeader className="bg-warning text-dark">
                                        <i className="fas fa-exclamation-triangle me-2"></i>
                                        {this.getSessionExpiredMessage().title}
                                    </ModalHeader>
                                    <ModalBody>
                                        <p className="mb-2">{this.getSessionExpiredMessage().message}</p>
                                        {this.getSessionExpiredMessage().reasons.length > 0 && (
                                            <ul className="mb-3">
                                                {this.getSessionExpiredMessage().reasons.map((reason, index) => (
                                                    <li key={index} className="text-muted">{reason}</li>
                                                ))}
                                            </ul>
                                        )}
                                        <div className="alert alert-info mb-0">
                                            <strong>Langkah selanjutnya:</strong><br />
                                            {this.getSessionExpiredMessage().action}
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="primary" onClick={this.handleSessionExpiredClose}>
                                            <i className="fas fa-envelope me-2"></i>
                                            Masukkan Email Kembali
                                        </Button>
                                    </ModalFooter>
                                </Modal>

                                {this.state.page == -5 ? (
                                    <Page1Email onEmailKonfirmationClick={this.onEmailKonfirmationClick} errors={errors} touched={touched} values={values} isValid={isValid} state={state} setFieldValue={setFieldValue}
                                        onValueChange={this.onValueChange}
                                        setFieldTouched={setFieldTouched} onAgree={this.onAgree} />
                                ) : null}


                                {this.state.page == -4 ? (
                                    <ChooseBank nowPilihBank={this.nowPilihBank} values={values} setFieldValue={setFieldValue} />
                                ) : null}

                                {this.state.page == -3 && values.BankCode2 == 'BCA' ? (
                                    <BankValidation nowVerifikasiDataPribadi={this.nowVerifikasiDataPribadi} setNorek={this.setNorek} setNamaPemegangRekening={this.setNamaPemegangRekening}
                                        setFieldValue={setFieldValue} values={values} setFieldTouched={setFieldTouched} />
                                ) : null}
                                {this.state.page == -3 && values.BankCode2 == 'BRI' ? (
                                    <BankValidationBRI nowVerifikasiDataPribadi={this.nowVerifikasiDataPribadi} setNorek={this.setNorek} setNamaPemegangRekening={this.setNamaPemegangRekening}
                                        setFieldTouched={setFieldTouched} saveTmpData={this.saveTmpData}
                                        showSessionExpiredModal={this.showSessionExpiredModal}
                                        setFieldValue={setFieldValue} values={values} />
                                ) : null}

                                {this.state.page == 0 ? (
                                    <Fade in={this.state.page == 0}>
                                        {/* <Button type="button" className="btn btn-secondary btn-sm" onClick={() => this.copyData(setFieldValue, values)} >Copy Data</Button> */}
                                        <Page1PersonalData errors={errors} touched={touched} values={values} state={state} props={props}
                                            onValueChange={this.onValueChange}
                                            setFieldValue={setFieldValue}
                                            toggleModalKodeArea={this.toggleModalKodeArea}
                                            handleChange={handleChange} handleBlur={handleBlur}
                                            requestResidentialCities={this.props.requestResidentialCities}
                                            onResidentIdemIdentity={this.onResidentIdemIdentity}
                                            imageChange={this.imageChange} onPhotoNPWPClick={this.onPhotoNPWPClick}
                                        />
                                    </Fade>
                                ) : null}

                                {this.state.page == 1 ? (
                                    <Fade in={this.state.page == 1}>
                                        <Page4Job errors={errors} touched={touched} values={values} state={state} occupations={occupations}
                                            positions={positions} props={props} setFieldValue={setFieldValue}
                                            onCorrespondenceProvinceChange={this.onCorrespondenceProvinceChange}
                                            onPositionChange={this.onPositionChange}
                                            onBusinessFieldChange={this.onBusinessFieldChange}
                                            onOccupationChange={this.onOccupationChange}
                                            onPenghasilanPerTahunChange={this.onPenghasilanPerTahunChange}
                                            onFundSourceChange={this.onFundSourceChange}
                                            onTINSSNMandatoryChange={this.onTINSSNMandatoryChange}
                                            onHaveAccountsInOtherBank={this.onHaveAccountsInOtherBank}
                                            handleBlur={handleBlur} handleChange={handleChange}
                                            toggleModalKodeArea={this.toggleModalKodeArea}
                                            imageChange={this.imageChange}
                                            onValueChange={this.onValueChange}
                                        />
                                    </Fade>
                                ) : null}

                                {this.state.page == -2 ? (
                                    <Fade in={this.state.page == -2}>
                                        <Page6DokumenPendukung errors={errors} touched={touched} values={values} state={state} imageChange={this.imageChange} validateForm={validateForm}
                                            fotoSelfieKTP={this.fotoSelfieKTP} setFieldValue={setFieldValue}
                                            takePhoto={this.takePhoto}
                                            onSnapPhoto={this.onSnapPhoto}
                                            isValid={isValid} setFieldTouched={setFieldTouched}
                                            onNextDokumenPendukungClick={this.onNextDokumenPendukungClick}
                                        />
                                    </Fade>
                                ) : null}

                                {this.state.page == 2 ? (
                                    <Fade in={this.state.page == 2}>
                                        <Page5AgreementPernyataan onAgree={this.onAgree} setFieldValue={setFieldValue} errors={errors} touched={touched} values={values} />
                                    </Fade>
                                ) : null}


                                {this.state.page == 3 ? (
                                    <Fade in={this.state.page == 3}>
                                        {values.BankCode2 === "BCA" ?
                                            <Page5Agreement onAgree={this.onAgree} setFieldValue={setFieldValue} errors={errors} touched={touched} values={values} /> :
                                            <Page5AggrementPernyataanBRI onAgree={this.onAgree} setFieldValue={setFieldValue} errors={errors} touched={touched} values={values} />
                                        }
                                    </Fade>
                                ) : null}

                                {this.state.page == 4 ? (
                                    <React.Fragment>
                                        <Fade in={this.state.page == 4}>
                                            <Page6Summary errors={errors} touched={touched} values={values} state={state} props={props} occupations={occupations} reloadCaptcha={this.reloadCaptcha} />
                                        </Fade>



                                        {Object.entries(errors).map(([fieldName, errorMessage]) =>
                                            <li key={fieldName} class='text-danger'>
                                                {fieldName} : {errorMessage}
                                            </li>
                                        )}


                                        <Button
                                            type="button"
                                            color="primary"
                                            onClick={() => this.backPage(isValid, setFieldTouched)}>&lt; Sebelumnya</Button><span> </span>

                                        <Button
                                            color="primary"
                                            type="submit"

                                        >Kirim Data</Button>

                                    </React.Fragment>
                                ) : (
                                    null
                                )}
                                <div className="row">
                                    <div className="col text-left">
                                        {(this.state.page > 0 && this.state.page < 4) ? (
                                            <React.Fragment>
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => this.backPage(isValid, setFieldTouched)}>&#8592; Sebelumnya</Button><span> </span>
                                            </React.Fragment>
                                        ) : null}
                                    </div>
                                    <div className="col text-center">
                                        {this.state.page >= 0 && this.state.page != 4 ? (
                                            <div>
                                                <Button type="button" color="secondary" onClick={() => this.saveTmpDataManual(values, this.state.page)}>Simpan Draft</Button>
                                            </div>
                                        ) : (null)}

                                        {this.state.page >= -3 ? (
                                            <div>
                                                <Button color='secondary' outline size="sm" onClick={() => this.cleanUpData(values)} >Bersihkan Data</Button>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="col text-right">
                                        {this.state.page >= 0 && this.state.page != 4 ? (
                                            <div>
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => this.nextPage(errors, isValid, setFieldTouched, values, setFieldValue)}>Selanjutnya &#8594;</Button>
                                            </div>
                                        ) : (null)}
                                    </div>
                                </div>
                                {/*<Persist name="registrasi" />*/}
                            </Form>
                        )}
                    </Formik>
                    <div ref={el => { this.el = el; }} />
                </Container>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    occupations: state.occupations.entities,
    positions: state.positions.entities,
    businessFields: state.businessFields.entities,
    partnerOrParentPositions: state.positions.partnerOrParentPositionEntities,
    partnerOrParentBusinessFields: state.businessFields.partnerOrParentBusinessFieldEntities,
    provinces: state.province.entities,
    cities: state.city.entities,
    accountOfficers: state.accountOfficers.entities,
    districts: state.city.districtEntities,
    subDistricts: state.city.subDistrictEntities,
    residentialCities: state.city.residentialCitiesEntities,
    residentialDistricts: state.city.residentialDistrictEntities,
    residentialSubDistricts: state.city.residentialSubDistrictEntities,
    npwpCities: state.city.npwpCitiesEntities,
    npwpDistricts: state.city.npwpDistrictEntities,
    npwpSubDistricts: state.city.npwpSubDistrictEntities,
    boIdentityCities: state.city.boIdentityCitiesEntities,
    boIdentityDistricts: state.city.boIdentityDistrictEntities,
    boIdentitySubDistricts: state.city.boIdentitySubDistrictEntities,
    boResidentialCities: state.city.boResidentialCitiesEntities,
    boResidentialDistricts: state.city.boResidentialDistrictEntities,
    boResidentialSubDistricts: state.city.boResidentialSubDistrictEntities,
    boPositions: state.positions.boPositionEntities,
    boBusinessFields: state.businessFields.boBusinessFieldEntities,
    correspondenceCities: state.city.correspondenceCitiesEntities,
    banks: state.bank.entities,
    register: state.register.entity,
    registerStatus: state.register.status
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestOccupations: occupationAction.requestOccupations,
        requestPositions: positionActions.requestPositions,
        requestBusinessFields: businessFieldActions.requestBusinessFields,
        requestPartnerOrParentPositions: positionActions.requestPartnerOrParentPositions,
        requestPartnerOrParentBusinessFields: businessFieldActions.requestPartnerOrParentBusinessFields,
        requestProvinces: provinceActions.requestProvinces,
        requestCities: cityActions.requestCities,
        requestResidentialCities: cityActions.requestResidentialCities,
        requestResidentialDistricts: cityActions.requestResidentialDistricts,
        requestResidentialSubDistricts: cityActions.requestResidentialSubDistricts,
        requestCorrespondenceCities: cityActions.requestCorrespondenceCities,
        requestAccountOfficers: accountOfficerActions.requestAccountOfficer,
        requestDistrict: cityActions.requestDistrict,
        requestSubDistrict: cityActions.requestSubDistrict,
        requestNPWPCities: cityActions.requestNPWPCities,
        requestNPWPDistricts: cityActions.requestNPWPDistricts,
        requestNPWPSubDistricts: cityActions.requestNPWPSubDistricts,
        requestBOIdentityCities: cityActions.requestBOIdentityCities,
        requestBOIdentityDistricts: cityActions.requestBOIdentityDistricts,
        requestBOIdentitySubDistricts: cityActions.requestBOIdentitySubDistricts,
        requestBOResidentialCities: cityActions.requestBOResidentialCities,
        requestBOResidentialDistricts: cityActions.requestBOResidentialDistricts,
        requestBOResidentialSubDistricts: cityActions.requestBOResidentialSubDistricts,
        requestBOPositions: positionActions.requestBOPositions,
        requestBOBusinessFields: businessFieldActions.requestBOBusinessFields,
        requestBanks: bankActions.requestBanks,
        createCustomer: registerActions.createCustomer,
        customerActivation: registerActions.customerActivation,
        checkRegisterStatus: registerActions.checkRegisterStatus
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FrmRegister);



// WEBPACK FOOTER //
// ./src/components/FrmRegister.js